import { Opcion } from "./opcion.model";

export interface IRespuesta {
  idPregunta: string;
  idRespuesta?: string;
  idRango?: string;
  valorRango: number;
  valorRespuesta: string;
  otroTexto: string;
}

export class Respuesta implements IRespuesta {

  idPregunta: string;
  idRespuesta?: string;
  idRango?: string;
  valorRango: number;
  valorRespuesta: string;
  otroTexto: string;

  constructor(model: IRespuesta) {
    this.idRespuesta = model.idRespuesta;
    this.idPregunta = model.idPregunta;
    this.valorRango = model.valorRango;
    this.valorRespuesta = model.valorRespuesta;
    this.otroTexto = model.otroTexto;
  }

}
